import { Sentry } from '@/helpers/sentry';
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { getGuestLocale } from '@/helpers/guestLocale'

import deDEAccount from '@/locales/deDE/account.json'
import deDEAuth from '@/locales/deDE/auth.json'
import deDECommon from '@/locales/deDE/common.json'
import deDEErrors from '@/locales/deDE/errors.json'
import deDEHome from '@/locales/deDE/home.json'
import deDESnipe from '@/locales/deDE/snipe.json'
import deDESubscription from '@/locales/deDE/subscription.json'
import deDETours from '@/locales/deDE/tours.json'
import enUSAccount from '@/locales/enUS/account.json'
import enUSAuth from '@/locales/enUS/auth.json'
import enUSCommon from '@/locales/enUS/common.json'
import enUSErrors from '@/locales/enUS/errors.json'
import enUSHome from '@/locales/enUS/home.json'
import enUSSnipe from '@/locales/enUS/snipe.json'
import enUSSubscription from '@/locales/enUS/subscription.json'
import enUSTours from '@/locales/enUS/tours.json'
import esESAccount from '@/locales/esES/account.json'
import esESAuth from '@/locales/esES/auth.json'
import esESCommon from '@/locales/esES/common.json'
import esESErrors from '@/locales/esES/errors.json'
import esESHome from '@/locales/esES/home.json'
import esESSnipe from '@/locales/esES/snipe.json'
import esESSubscription from '@/locales/esES/subscription.json'
import esESTours from '@/locales/esES/tours.json'
import esMXAccount from '@/locales/esMX/account.json'
import esMXAuth from '@/locales/esMX/auth.json'
import esMXCommon from '@/locales/esMX/common.json'
import esMXErrors from '@/locales/esMX/errors.json'
import esMXHome from '@/locales/esMX/home.json'
import esMXSnipe from '@/locales/esMX/snipe.json'
import esMXSubscription from '@/locales/esMX/subscription.json'
import esMXTours from '@/locales/esMX/tours.json'
import frFRAccount from '@/locales/frFR/account.json'
import frFRAuth from '@/locales/frFR/auth.json'
import frFRCommon from '@/locales/frFR/common.json'
import frFRErrors from '@/locales/frFR/errors.json'
import frFRHome from '@/locales/frFR/home.json'
import frFRSnipe from '@/locales/frFR/snipe.json'
import frFRSubscription from '@/locales/frFR/subscription.json'
import frFRTours from '@/locales/frFR/tours.json'
import itITAccount from '@/locales/itIT/account.json'
import itITAuth from '@/locales/itIT/auth.json'
import itITCommon from '@/locales/itIT/common.json'
import itITErrors from '@/locales/itIT/errors.json'
import itITHome from '@/locales/itIT/home.json'
import itITSnipe from '@/locales/itIT/snipe.json'
import itITSubscription from '@/locales/itIT/subscription.json'
import itITTours from '@/locales/itIT/tours.json'
import ptBRAccount from '@/locales/ptBR/account.json'
import ptBRAuth from '@/locales/ptBR/auth.json'
import ptBRCommon from '@/locales/ptBR/common.json'
import ptBRErrors from '@/locales/ptBR/errors.json'
import ptBRHome from '@/locales/ptBR/home.json'
import ptBRSnipe from '@/locales/ptBR/snipe.json'
import ptBRSubscription from '@/locales/ptBR/subscription.json'
import ptBRTours from '@/locales/ptBR/tours.json'
import ruRUAccount from '@/locales/ruRU/account.json'
import ruRUAuth from '@/locales/ruRU/auth.json'
import ruRUCommon from '@/locales/ruRU/common.json'
import ruRUErrors from '@/locales/ruRU/errors.json'
import ruRUHome from '@/locales/ruRU/home.json'
import ruRUSnipe from '@/locales/ruRU/snipe.json'
import ruRUSubscription from '@/locales/ruRU/subscription.json'
import ruRUTours from '@/locales/ruRU/tours.json'

i18n
  .use(initReactI18next)
  .init({
    lng: getGuestLocale(),
    fallbackLng: 'enUS',
    defaultNS: 'common',
    ns: ['common', 'home', 'auth', 'subscription', 'account', 'snipe', 'errors', 'tours'],
    resources: {
      enUS: {
        common: enUSCommon,
        home: enUSHome,
        auth: enUSAuth,
        subscription: enUSSubscription,
        account: enUSAccount,
        snipe: enUSSnipe,
        errors: enUSErrors,
        tours: enUSTours,
      },
      deDE: {
        common: deDECommon,
        home: deDEHome,
        auth: deDEAuth,
        subscription: deDESubscription,
        account: deDEAccount,
        snipe: deDESnipe,
        errors: deDEErrors,
        tours: deDETours,
      },
      frFR: {
        common: frFRCommon,
        home: frFRHome,
        auth: frFRAuth,
        subscription: frFRSubscription,
        account: frFRAccount,
        snipe: frFRSnipe,
        errors: frFRErrors,
        tours: frFRTours,
      },
      itIT: {
        common: itITCommon,
        home: itITHome,
        auth: itITAuth,
        subscription: itITSubscription,
        account: itITAccount,
        snipe: itITSnipe,
        errors: itITErrors,
        tours: itITTours,
      },
      esES: {
        common: esESCommon,
        home: esESHome,
        auth: esESAuth,
        subscription: esESSubscription,
        account: esESAccount,
        snipe: esESSnipe,
        errors: esESErrors,
        tours: esESTours,
      },
      esMX: {
        common: esMXCommon,
        home: esMXHome,
        auth: esMXAuth,
        subscription: esMXSubscription,
        account: esMXAccount,
        snipe: esMXSnipe,
        errors: esMXErrors,
        tours: esMXTours,
      },
      ptBR: {
        common: ptBRCommon,
        home: ptBRHome,
        auth: ptBRAuth,
        subscription: ptBRSubscription,
        account: ptBRAccount,
        snipe: ptBRSnipe,
        errors: ptBRErrors,
        tours: ptBRTours,
      },
      ruRU: {
        common: ruRUCommon,
        home: ruRUHome,
        auth: ruRUAuth,
        subscription: ruRUSubscription,
        account: ruRUAccount,
        snipe: ruRUSnipe,
        errors: ruRUErrors,
        tours: ruRUTours,
      },
    },
    interpolation: {
      escapeValue: false, // React already handles XSS
    },
    saveMissing: import.meta.env.DEV,
    missingKeyHandler: import.meta.env.DEV
      ? (lngs: readonly string[], ns: string, key: string) => {
          Sentry.logger.warn(`[i18n] Missing key: ${ns}:${key} (${lngs.join(', ')})`)
        }
      : undefined,
  })

export default i18n
